<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import ArrayUtil from '../../utilities/ArrayUtil'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import FormsApi from '../../api/FormsApi'
import FormAccessApi from '../../api/FormAccessApi'
import ReportingGroupApi from '../../api/ReportingGroupApi'
import InputTypeLovApi from '../../api/InputTypeLovApi'
import FormFieldsApi from '../../api/FormFieldsApi'
import ValidationCardApi from '../../api/ValidationCardApi'
/** UI Components */
import { Checkbox } from 'buefy/dist/components/checkbox'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Select } from 'buefy/dist/components/select'
import { Message } from 'buefy/dist/components/message'
import { Switch } from 'buefy/dist/components/switch'
import { Steps,StepItem } from 'buefy/dist/components/steps'
import EditFormFieldsForm from '../../components/EditFormFieldsForm'

const STATIC_GRPNAME_GOV = 'Government Agencies';

import _ from 'lodash'  

export default {
    name : "CopyFormView",
    components: {
        'b-checkbox' : Checkbox,
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-select' : Select,
        'b-steps' : Steps,
        'b-step-item' : StepItem,
        'EditFieldsForm' : EditFormFieldsForm,
        'b-message' : Message,
        'b-switch' : Switch
    },
    data() {
        return {
            activeStep : 0,
            originalFormData : {},
            newFormData : {
                formName : "",
                repGroupAccess : [],
                repEntityAccess : [],
                repUnitAccess : []
            },
            repGroupLov : [],
            govAgencyGroup : null,
            hasNavigation : true,
            isAnimates : true,
            isStepsClickable : true,
            formNameInvalid : null,
            formNamePromise : false,
            formNameErrorMessage : "",
            groupedFormAccess : [],
            inputTypesLov : [],
            formAccessBreakdown : {
                repGroupAccess : {
                    add : [],
                    remove : []
                },
                repEntityAccess : {
                    add : [],
                    remove : []
                },
                repUnitAccess : {
                    add : [],
                    remove : []
                }
            },
            selectedReportingYear : null,
            routeReportingYear : null,
            newReportingYear: null,
            reportingYearLov : [],
            enableFileUpload : false,
            isLoading : false,
            isFullPage : false,
            globalError : {
                show : false,
                message : ""
            },
            globalLoading : null,
            newFormId: null,
            isFormNameAccessSuccess: true,
            isFormAccessSettingSuccess: false,
            areFormFieldsAdded : false
        }
    },
    computed: {
        ...mapState({
            profile : "userProfile",
            token : "xOreAuth"
        }),
        isFormValid(){
            if (!this.selectedReportingYear) {
                return false;
            }

            if (this.newFormData.formName.trim()=="") {
                return false
            }
            if (this.newFormData.repGroupAccess.length==0) {
                return false
            }

            var repGroupGov = this.repGroupLov.filter(group=>{
                return (group.reportingGroup==this.govAgencyGroup)
            });
                
            var repGroupGovId = repGroupGov[0].repGroupId;

            // Check if 'Government Agencies' option is selected
            if (this.isAccessNew(0,repGroupGovId)) {

                var selectedGovAgencies = 0;

                // Check if at least one of the agencies is checked
                this.repGroupLov.forEach(group=>{
                    if (group.repGroupId==repGroupGovId) {
                        group.reportingEntities.forEach(entity=>{
                            if (ArrayUtil.inArray(this.newFormData.repEntityAccess,entity.repEntityId)) {
                                selectedGovAgencies++;
                            }
                        })
                    }
                });

                // Prompt for warning to select at least one agency
                if (selectedGovAgencies==0) {
                    // Please select at least one rep entity.
                    return false;
                }
            }

            /** Check the rest of rep groups */
            let repGroupWithError = [];

            this.newFormData.repGroupAccess.forEach(grpId=>{
                if (grpId!=repGroupGovId) {

                    let groupData = this.repGroupLov.filter(grp=>{
                        return grp.repGroupId==grpId;
                    });

                    if (groupData.length) {
                        let countSelected = 0;
                        if (groupData[0].reportingEntities) {
                            let checkedEntities = groupData[0].reportingEntities.forEach(ent=>{
                                if (ArrayUtil.inArray(this.newFormData.repEntityAccess,ent.repEntityId)) {
                                    countSelected++;
                                }
                            });
                            if (countSelected==0){
                                repGroupWithError.push({
                                    reportingGroup : groupData[0].reportingGroup,
                                    repGroupId : groupData[0].repGroupId,
                                    countSelected
                                })
                            }
                        } 
                    }
                    
                }
            });

            if (repGroupWithError.length > 0) {
                return false;
            }
            return true;



            /// old algo

            var repGroupMining = this.repGroupLov.filter(group=>{
                return (group.reportingGroup=='Mining Companies')
            });
            var repGroupMiningId = repGroupMining[0].repGroupId;

            // Check if 'Mining Companies' option is selected
            if (this.isAccessNew(0,repGroupMiningId)) {
                var selectedCompanies = 0;
                // Check if at least one of the agencies is checked
                this.repGroupLov.forEach(group=>{
                    if (group.repGroupId==repGroupMiningId) {
                        group.reportingEntities.forEach(entity=>{
                            if (this.isAccessNew(1,entity.repEntityId)){
                                selectedCompanies++;
                            }
                        })
                    }
                });
                // Prompt for warning to select at least one agency
                if (selectedCompanies==0) {
                    // Please select at least one rep entity.
                    return false;
                }
            }

            var repGroupOG = this.repGroupLov.filter(group=>{
                return (group.reportingGroup=='Oil & Gas Companies')
            });
            var repGroupOGId = repGroupOG[0].repGroupId;

            // Check if 'Oil & Gas Companies' option is selected
            if (this.isAccessNew(0,repGroupOGId)) {
                var selectedCompanies = 0;
                // Check if at least one of the agencies is checked
                this.repGroupLov.forEach(group=>{
                    if (group.repGroupId==repGroupOGId) {
                        group.reportingEntities.forEach(entity=>{
                            if (this.isAccessNew(1,entity.repEntityId)){
                                selectedCompanies++;
                            }
                        })
                    }
                });
                // Prompt for warning to select at least one agency
                if (selectedCompanies==0) {
                    // Please select at least one rep entity.
                    return false;
                }
            }

            return true;
        },
        nameAccessChanged(){
            if (this.originalFormData.reportingYear!=this.selectedReportingYear) {
                return true
            }
            if (this.originalFormData.formName!=this.newFormData.formName) {
                return true
            }
            if (this.originalFormData.repGroupAccess.toString()!=this.newFormData.repGroupAccess.toString()) {
                return true
            }
            if (this.originalFormData.repEntityAccess.toString()!=this.newFormData.repEntityAccess.toString()) {
                return true
            }
            if (this.originalFormData.repUnitAccess.toString()!=this.newFormData.repUnitAccess.toString()) {
                return true
            }
            return false
        },
        backLink(){
            let backLink = "/admin/forms";
            if (this.selectedReportingYear) {
                backLink += "?reportingYear="+this.selectedReportingYear;
            }
            return backLink;
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        // this.isTokenValid();
        
        // Get list of reporting groups, entities and units for access
        this.getRepGroups();
        // Get input type lookup for fields section
        this.getInputTypesLov();        

        // Get Form Data
        if (this.$route.params) {
            try {
                this.formId = parseInt(this.$route.params.formId,10);
            }
            catch(formIdError){}
        }

        if (this.$route.query) {
            try {
                if (this.$route.query.step) {
                    this.activeStep = parseInt(this.$route.query.step,10);
                }
            }
            catch(formIdError){}

            try {
                if (this.$route.query.reportingYear) {
                    this.routeReportingYear = parseInt(this.$route.query.reportingYear,10)
                }
            }
            catch(repYrErr){}

            try {
                if (this.$route.query.newReportingYear) {
                    this.newReportingYear = parseInt(this.$route.query.newReportingYear,10)
                }
            }
            catch(newRepYear){}
        }

        this.getReportingYearLov();
    },
    methods: {
        ...mapMutations({
            clearAppData : "clearAppData",
            setAllFormsData: "updateAllFormsData"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                
                            }
                        }
                    }
                } 
            })
            .catch(error=>{
            })
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getRepGroups(){
            this.govAgencyGroup = STATIC_GRPNAME_GOV;
            this.repGroupLov = [];

            ReportingGroupApi.getAllData()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.repGroupLov = response.data;

                        /** Get Gov Agency group for reference */
                        let govgroup =this.repGroupLov.filter(grp=>{
                            return grp.reportingGroup.match(/government agenc/gi);
                        });
                        if (govgroup.length > 0) {
                            this.govAgencyGroup = govgroup[0].reportingGroup;
                        }
                        else {
                            this.govAgencyGroup = STATIC_GRPNAME_GOV;
                        }
                    }
                    else {
                        this.promptServerError({response},'ReportingGroup.getAllGroupData');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingGroup.getAllGroupData');
            });
        },
        getInputTypesLov(){
            InputTypeLovApi.get()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.inputTypesLov = response.data;
                    }
                    else {
                        this.promptServerError({response},'InputTypeLov.get');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'InputTypeLov.get');
            });
        },
        getReportingYearLov(){
            // this.isLoading = true;
            this.globalLoading = this.$loading.open({
                container: null
            });
            this.reportingYearLov = [];
            this.selectedReportingYear = null;
            let staticYrs = AppResourceUtil.getRepYrStaticLov();

            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {

                        let repYearInDb = [];
                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }
                        
                        /* Merge static years and rep year found in the database */ 
                        let allRepYrsLov = this.$_.union(staticYrs,repYearInDb);

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = allRepYrsLov.sort().reverse();

                        if (this.formId!=null) {
                            this.getForm();
                        }
                        else {
                            this.globalLoading.close()
                        }
                        // if (this.$route.query) {
                        //     try {
                        //         this.selectedReportingYear = parseInt(this.$route.query.reportingYear,10)
                        //     }
                        //     catch(formIdErr){}
                        // }

                        this.isLoading = false;
                    }
                    else {
                        this.isLoading = false;
                        this.globalLoading.close()
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },
        getForm(){
            if (!this.formId) {
                this.globalLoading.close()
                this.$dialog.alert({
                    title: 'Error',
                    message: 'No form found. Please reload and try again.',
                    type: 'is-danger'
                });
                return false
            }
            FormsApi.getOne(this.formId)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error){
                        /* if (response.data.isPublished==true) {
                            this.globalLoading.close()
                            this.$dialog.alert({
                                title: 'Error',
                                message: 'This form is already published. Edit is no longer allowed.',
                                type: 'is-danger'
                            });
                            this.$router.push({path:"/admin/forms/"+this.formId+'/preview?reportingYear='+this.routeReportingYear});
                            return false
                        } */

                        this.originalFormData = response.data;
                        if (response.data.reportingYear) {
                            this.originalFormData.reportingYear = response.data.reportingYear;

                            /** Use newReportingYear to assign reporting year */
                            if (this.newReportingYear !== null) {
                                this.selectedReportingYear = this.newReportingYear
                            } else {
                                this.selectedReportingYear = response.data.reportingYear
                            }
                        }

                        this.newFormData.formId = null                        
                        this.newFormData.formName = `${this.originalFormData.formName} - Copy`;

                        this.originalFormData.repGroupAccess = [];
                        this.originalFormData.repEntityAccess = [];
                        this.originalFormData.repUnitAccess = [];
                        this.enableFileUpload = response.data.filesEnabled;
                        this.setAccessData();
                    }
                    else {
                        this.globalLoading.close()
                        this.promptServerError({response},'Form.getOne');
                    }
                }
            })
            .catch(error=>{
                this.globalLoading.close()
                this.promptServerError(error,'Form.getOne');
            });
        },
        setAccessData(){
            if (this.originalFormData.groupedFormAccessData.length > 0) {
                this.groupedFormAccess = []
                this.originalFormData.groupedFormAccessData.forEach(group=>{

                    /*this.$set(group,'sameSubmissionType',this.hasSameSubmissionType(group))
                    if (group.sameSubmissionType==true) {
                        group.subTypeApplied = true
                    }
                    else {
                        group.subTypeApplied = false
                    }

                    this.$set(group,'sameDisplayOption',this.hasSameDisplayOption(group))
                    if (group.sameDisplayOption==true) {
                        group.displayOptApplied = true
                    }
                    else {
                        group.displayOptApplied = false
                    }
                    if (group.sameSubmissionType == true && group.sameDisplayOption == true) {
                        this.$set(group,'appliedToAll',true)
                    }
                    else {
                        this.$set(group,'appliedToAll',false)
                    }*/
                    
                    group.accessLevel = 'Reporting Group'
                    this.newFormData.repGroupAccess.push(group.repGroupIdFk)
                    this.originalFormData.repGroupAccess.push(group.repGroupIdFk)

                    if (group.reportingEntities.length > 0) {
                        group.reportingEntities.forEach(entity=>{
                            entity.accessLevel = 'Reporting Entity'
                            this.newFormData.repEntityAccess.push(entity.repEntityIdFk);
                            this.originalFormData.repEntityAccess.push(entity.repEntityIdFk);

                            if (entity.reportingUnits.length > 0) {
                                entity.reportingUnits.forEach(unit=>{
                                    entity.accessLevel = 'Reporting Unit'
                                    this.newFormData.repUnitAccess.push(unit.repUnitIdFk);
                                    this.originalFormData.repUnitAccess.push(unit.repUnitIdFk);
                                })
                            }
                        })
                    }
                    this.groupedFormAccess.push(group)
                })
            }
            // this.globalLoading.close()
            this.addNewFormData()
            
        },
        checkFormName: _.debounce(function(){
            this.formNameInvalid = null;
            this.formNameErrorMessage = "";
            if (this.newFormData.formName.trim()=="") {
                return false
            }
            if (this.newFormData.formName.trim().length > 3) {
                this.formNamePromise = true;
                FormsApi.getFormName({
                    formName: this.newFormData.formName,
                    formId: this.formId
                })
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            this.formNameInvalid = response.data.isExisting;
                            this.formNamePromise = false;
                            if (this.formNameInvalid) {
                                // this.formNameErrorMessage = "Form name already exists. Please enter a new name.";
                                this.formNameErrorMessage = "There's an existing form with the same name. If you're to keep this name, please ensure that reporting group access is different.";
                            }
                            else {
                                this.formNameErrorMessage = "Form name is valid.";
                            }
                        }
                        else {
                            this.formNamePromise = false;
                            this.promptServerError({response},'Form.getFormName');
                        }
                    }
                })
                .catch(error=>{
                    this.formNamePromise = false;
                    this.promptServerError(error,'Form.getFormName');
                });
            }
        },350),
        isGroupSelected(repGroup) {
            if (repGroup) {
                return ArrayUtil.inArray(this.newFormData.repGroupAccess,repGroup.repGroupId)
            }
        },
        isEntitySelected(entity){
            if (entity) {
                return ArrayUtil.inArray(this.newFormData.repEntityAccess,entity.repEntityId)
            }
        },
        govGroupValid(){
            if (this.repGroupLov) {

                var repGroupGov = this.repGroupLov.filter(group=>{
                    return (group.reportingGroup==this.govAgencyGroup)
                });
                    
                var repGroupGovId = repGroupGov[0].repGroupId;

                // Check if 'Government Agencies' option is selected
                if (ArrayUtil.inArray(this.newFormData.repGroupAccess,repGroupGovId)) {

                    var selectedGovAgencies = 0;

                    // Check if at least one of the agencies is checked
                    this.repGroupLov.forEach(group=>{
                        if (group.repGroupId==repGroupGovId) {
                            group.reportingEntities.forEach(entity=>{
                                if (ArrayUtil.inArray(this.newFormData.repEntityAccess,entity.repEntityId)) {
                                    selectedGovAgencies++;
                                }
                            })
                        }
                    });

                    // Prompt for warning to select at least one agency
                    if (selectedGovAgencies==0) {
                        // Please select at least one rep entity.
                        return false;
                    }
                }
            }
            return true;
        },
        otherGroupValid(){
            /** Check the rest of rep groups */
            let repGroupWithError = [];

            var repGroupGov = this.repGroupLov.filter(group=>{
                return (group.reportingGroup==this.govAgencyGroup)
            });
                
            var repGroupGovId = repGroupGov[0].repGroupId;

            if (this.newFormData.repGroupAccess) {
                this.newFormData.repGroupAccess.forEach(grpId=>{
                    if (grpId!=repGroupGovId) {

                        let groupData = this.repGroupLov.filter(grp=>{
                            return grp.repGroupId==grpId;
                        });

                        if (groupData.length) {
                            let countSelected = 0;
                            if (groupData[0].reportingEntities) {
                                let checkedEntities = groupData[0].reportingEntities.forEach(ent=>{
                                    if (ArrayUtil.inArray(this.newFormData.repEntityAccess,ent.repEntityId)) {
                                        countSelected++;
                                    }
                                });
                                if (countSelected==0){
                                    repGroupWithError.push({
                                        reportingGroup : groupData[0].reportingGroup,
                                        repGroupId : groupData[0].repGroupId,
                                        countSelected
                                    })
                                }
                            } 
                        }
                        
                    }
                });
                if (repGroupWithError.length > 0) {
                    return false
                }
            }
            return true;
        },
        saveFormChanges(){
            this.closeError();
            switch(this.activeStep) {
                case 0:
                    if (!this.nameAccessChanged) {
                        this.showError('No changes detected.')
                        return false
                    }
                    this.validateNameAcccess();
                    break;
                case 1:
                    // save setting
                    break;
                case 2:
                    // save fields
                    // delete existing fields
                    // check for fields without IDs -> these are new for adding
                    // get those deleted
                    break;
            }
        },
        validateNameAcccess(){
            this.closeError();

            if (this.newFormData.formName.trim()=="") {
                this.showError('Form name is required.');
                return false;
            }

            if (this.govGroupValid()==false) {
                this.showError('Please select at least one entity from selected reporting group.');
                return false
            }

            if (this.otherGroupValid()==false){
                this.showError('Please select at least one entity from selected reporting group.');
                return false
            }

            // Check if there's new name
            this.updateName();           
            
            // Get new access and set which are for deletion
            this.getNewAccess();
            /** Chained this calls instead */
            //this.getAccessForRemoval();
            //this.updateAccess();
        },
        getNewAccess(){
            this.formAccessBreakdown.repGroupAccess.add = [];
            this.formAccessBreakdown.repEntityAccess.add = [];
            this.formAccessBreakdown.repUnitAccess.add = [];

            this.newFormData.repGroupAccess.forEach(repGroupId=>{
                if (this.isAccessOriginal(0,repGroupId)==false) {
                    this.formAccessBreakdown.repGroupAccess.add.push({
                        repGroupId : repGroupId
                    });
                }
            });

            this.newFormData.repEntityAccess.forEach(repEntityId=>{
                if (this.isAccessOriginal(1,repEntityId)==false) {
                    let p = this.getRepParentId(1,repEntityId);
                    this.formAccessBreakdown.repEntityAccess.add.push({
                        repGroupIdFk : p.repGroupIdFk,
                        repEntityId : repEntityId
                    });
                }
            });

            this.newFormData.repUnitAccess.forEach(repUnitId=>{
                if (this.isAccessOriginal(2,repUnitId)==false) {
                    let p = this.getRepParentId(2,repUnitId);
                    this.formAccessBreakdown.repUnitAccess.add.push({
                        repGroupIdFk : p.repGroupIdFk,
                        repEntityIdFk : p.repEntityIdFk,
                        repUnitId : repUnitId
                    });
                }
            });

            this.getAccessForRemoval();
        },
        getAccessForRemoval(){
            this.formAccessBreakdown.repGroupAccess.remove = [];
            this.formAccessBreakdown.repEntityAccess.remove = [];
            this.formAccessBreakdown.repUnitAccess.remove = [];

            // Reporting Group Access for REMOVAL
            this.originalFormData.repGroupAccess.forEach(repGroupId=>{
                if (this.isAccessNew(0,repGroupId)==false) {
                    this.formAccessBreakdown.repGroupAccess.remove.push({
                        accessId : this.getAccessId(0,repGroupId),
                        repGroupId: repGroupId
                    })
                }
            });

            // Reporting Entity Access for REMOVAL
            this.originalFormData.repEntityAccess.forEach(repEntityId=>{
                if (this.isAccessNew(1,repEntityId)==false) {
                    this.formAccessBreakdown.repEntityAccess.remove.push({
                        accessId : this.getAccessId(1,repEntityId),
                        repEntityId: repEntityId
                    })
                }
            });

            // Reporting Unit Access for REMOVAL
            this.originalFormData.repUnitAccess.forEach(repUnitId=>{
                if (this.isAccessNew(2,repUnitId)==false) {
                    this.formAccessBreakdown.repUnitAccess.remove.push({
                        accessId : this.getAccessId(2,repUnitId),
                        repUnitId: repUnitId
                    })
                }
            });

            this.updateAccess();
        },
        updateName(){
            if ( (this.newFormData.formName.trim()==this.originalFormData.formName.trim()) && 
                (this.selectedReportingYear==this.originalFormData.reportingYear) ) {
                // 'No new values of reporting year or form name detected.'
                return false;
            }
            let updateData = {
                formId : this.formId,
                updatedBy : this.profile.userId
            };
            if (this.newFormData.formName.trim()!==this.originalFormData.formName.trim()) {
                updateData.formName = this.newFormData.formName.trim();
            }            
            if (this.originalFormData.reportingYear!=this.selectedReportingYear) {
                updateData.reportingYear = this.selectedReportingYear;
            }
            FormsApi.updateName(updateData)
            .then(response=>{ 
                if (response.data) {
                    if (!response.data.error) {
                        this.$notification.open({
                            duration: 5000,
                            message: 'Form name updated.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                    }
                    else {
                        this.promptServerError({response},'Form.updateName');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Form.updateName');
            });
        },
        updateAccess(){
            let newCount = 0, removeCount = 0;
            for (var key in this.formAccessBreakdown) {
                newCount += this.formAccessBreakdown[key].add.length;
                removeCount += this.formAccessBreakdown[key].remove.length;
            }
            if (newCount > 0) {
                this.addNewAccess();
            }
            if (removeCount > 0) {
                this.removeAccess();
            }
        },
        addNewAccess(){
            let newAccess = [];
            if (this.formAccessBreakdown.repGroupAccess.add.length > 0) {
                this.formAccessBreakdown.repGroupAccess.add.forEach(a=>{
                    newAccess.push({
                        formIdFk : this.formId,
                        accessLevel : 'Reporting Group',
                        repGroupIdFk : a.repGroupId,
                        repEntityIdFk : null,
                        repUnitIdFk : null,
                        formSubmissionType : 'Single',
                        displayOption : 'List',
                        addedBy : this.profile.userId
                    });
                })
            }
            if (this.formAccessBreakdown.repEntityAccess.add.length > 0) {
                this.formAccessBreakdown.repEntityAccess.add.forEach(a=>{
                    newAccess.push({
                        formIdFk : this.formId,
                        accessLevel : 'Reporting Entity',
                        repGroupIdFk : a.repGroupIdFk,
                        repEntityIdFk : a.repEntityId,
                        repUnitIdFk : null,
                        formSubmissionType : 'Single',
                        displayOption : 'List',
                        addedBy : this.profile.userId
                    });
                })
            }
            if (this.formAccessBreakdown.repUnitAccess.add.length > 0) {
                this.formAccessBreakdown.repUnitAccess.add.forEach(a=>{
                    newAccess.push({
                        formIdFk : this.formId,
                        accessLevel : 'Reporting Unit',
                        repGroupIdFk : a.repGroupIdFk,
                        repEntityIdFk : a.repEntityIdFk,
                        repUnitIdFk : a.repUnitId,
                        formSubmissionType : 'Single',
                        displayOption : 'List',
                        addedBy : this.profile.userId
                    });
                })
            }
            
            FormAccessApi.addFromUpdate({
                formId  : this.formId,
                accessData : newAccess
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.$notification.open({
                            duration: 5000,
                            message: 'Form access updated. Added new access.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        // To get updated access for the next step
                        this.getForm();
                    }   
                    else {
                        this.promptServerError({response},'FormAccess.addFromUpdate');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormAccess.addFromUpdate');
            });
        },
        removeAccess(){
            let accessIds = [];
            for (var key in this.formAccessBreakdown) {
                if (this.formAccessBreakdown[key].remove.length > 0) {
                    this.formAccessBreakdown[key].remove.forEach(entry=>{
                        accessIds.push(entry.accessId);
                    })
                }
            }

            FormAccessApi.delete({
                accessIds
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.$notification.open({
                            duration: 5000,
                            message: 'Form access updated. Removed some access.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        // To get updated access for the next step
                        this.getForm();
                    }
                    else {
                        if (response.data.error.hasOwnProperty('code') &&
                            response.data.error.code==220) {
                            this.$dialog.alert({
                                title: 'Error: Unable to delete',
                                message: response.data.error.message,
                                type: 'is-danger'
                            });
                            return false;
                        }
                        this.promptServerError({response},'FormAccess.delete');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'FormAccess.delete');
            })
        },
        cancel(){
            // Check if there's progress in the forms
            if (this.nameAccessChanged && this.activeStep==0) {
                this.$dialog.confirm({
                    title: 'Confirmation',
                    message: 'You have unsaved changes. Are you sure you want to leave this page?',
                    cancelText: 'Stay',
                    confirmText: 'Leave Page',
                    type: 'is-warning',
                    onConfirm: () => {                        
                        this.$router.push({path:this.backLink});
                    }
                })
                return false;
            }
            // Go back to /forms
            this.$router.push({path:this.backLink});
        },
        getAccessId(level,inputId) {
            let returnAccessId = null;
            this.originalFormData.groupedFormAccessData.forEach(group=>{
                if (level==0) {
                    // if reporting group
                    if (group.repGroupIdFk==inputId) {
                        returnAccessId = group.accessId;
                    }
                }
                else {
                    if (group.reportingEntities.length > 0) {
                        group.reportingEntities.forEach(entity=>{
                            if (level==1) { 
                                // If reporting entity
                                if (entity.repEntityIdFk==inputId) {
                                    returnAccessId = entity.accessId;
                                }
                            }
                            else {
                                if (entity.reportingUnits.length > 0) {
                                    entity.reportingUnits.forEach(unit=>{
                                        // If reporting unit
                                        if (unit.repUnitIdFk==inputId) {
                                            returnAccessId = unit.accessId;
                                        }
                                    });
                                }
                            }      
                        });
                    }   
                }
            });
            return returnAccessId;
        },
        getRepParentId(level,inputId) {
            let parentId = {};
            this.repGroupLov.forEach(grp=>{
                if ( grp.reportingEntities.length > 0 ) {
                    grp.reportingEntities.forEach(entity=>{
                        if (level==1) {
                            if (entity.repEntityId==inputId) {
                                parentId = {
                                    repGroupIdFk : grp.repGroupId
                                };
                            }
                        }
                        if (level==2) {
                            if (entity.reportingUnits.length > 0) {
                                entity.reportingUnits.forEach(unit=>{
                                    if (unit.repUnitId==inputId) {
                                        parentId = {
                                            repGroupIdFk : grp.repGroupId,
                                            repEntityIdFk : entity.repEntityId
                                        };
                                    }
                                })
                            }
                        }
                        
                    })
                }
            });
            return parentId;
        },
        checkAccess(level,repGroup,entity) {
            let selectedGroup = this.getGroupEntitiesUnits(repGroup.repGroupId);
            if (level==0) {
                // When rep group is unchecked
                // uncheck also the entities/units
                let action = "";
                if (this.isAccessNew(0,repGroup.repGroupId)==false){
                    // unchecked
                    action = 'remove';
                }
                else {                    
                    // checked
                    action = 'add';
                }
                if (selectedGroup.entities.length > 0) {
                    this.markEntities(selectedGroup.entities,action,repGroup); // Change to formEntities 
                }
                if (selectedGroup.units.length > 0) {
                    this.markUnits(selectedGroup.units,action,repGroup,null); // Change to formUnits
                }
            }
            else if (level==1 && entity) {
                let action = "";
                if (this.isAccessNew(1,entity.repEntityId)==false){
                    // unchecked
                    action = 'remove';
                }
                else {                    
                    // checked
                    action = 'add';
                }
                if (selectedGroup.units.length > 0) {
                    if (entity.reportingUnits.length > 0) {
                        var repEntUnits = entity.reportingUnits.map(u=>{
                            return u.repUnitId
                        })
                        this.markUnits(selectedGroup.units,action,repGroup,repEntUnits); // Change to formUnits
                    }
                }
            }
        },
        getGroupEntitiesUnits(repGroupIdFk){
            let entities = [], formEntities = [];
            let units = [], formUnits = [];
            this.repGroupLov.forEach(group=>{
                if (group.repGroupId==repGroupIdFk) {
                    if (group.reportingEntities.length > 0) {
                        // Get Entities
                        group.reportingEntities.forEach(entity=>{
                            entities.push(entity.repEntityId);
                            if (this.isAccessOriginal(1,entity.repEntityId)) {
                                formEntities.push(entity.repEntityId)
                            }

                            // Get Units
                            if (entity.reportingUnits.length > 0) {
                                entity.reportingUnits.forEach(unit=>{
                                    units.push(unit.repUnitId)
                                    if (this.isAccessOriginal(2,unit.repUnitId)) {
                                        formUnits.push(unit.repUnitId)
                                    }
                                });
                            }
                        })
                    }
                }
            });
            return {
                entities,
                units,
                formEntities,
                formUnits
            }
        },
        markEntities(entityIds,action,repGroup){
            let newRepEntAccess = [];
            if (action=='remove') {
                // When unchecked
                this.newFormData.repEntityAccess.forEach(aId=>{
                    if (ArrayUtil.inArray(entityIds,aId)==false) {
                        newRepEntAccess.push(aId);
                    }
                });
                this.newFormData.repEntityAccess = newRepEntAccess
            }
            else {
                if (repGroup.reportingGroup!==this.govAgencyGroup) {
                    // When checked
                    entityIds.forEach(eId=>{
                        if (this.isAccessNew(1,eId)==false){
                            this.newFormData.repEntityAccess.push(eId);
                        }
                    })
                }
            }    
        },
        markUnits(unitIds,action,repGroup,repEntUnits){
            let newRepUnitAccess = [];
            if (action=='remove') {
                // When unchecked
                if (!repEntUnits) {
                    this.newFormData.repUnitAccess.forEach(aId=>{
                        if (ArrayUtil.inArray(unitIds,aId)==false) {
                            newRepUnitAccess.push(aId);
                        }  
                    })
                }
                else {
                    this.newFormData.repUnitAccess.forEach(aId=>{
                        if (ArrayUtil.inArray(repEntUnits,aId)==false) {
                            newRepUnitAccess.push(aId);
                        }  
                    })
                }
                this.newFormData.repUnitAccess = newRepUnitAccess;
            }
            else {
                // When checked
                unitIds.forEach(uId=>{
                    if (this.isAccessNew(2,uId)==false) {
                        this.newFormData.repUnitAccess.push(uId);
                    }
                });
            }    
        },
        isAccessOriginal(level,id) {
            switch(level) {
                case 0: // Reporting Group Access
                    return ArrayUtil.inArray(this.originalFormData.repGroupAccess,id);
                    break;
                case 1: // Reporting Entity Access
                    return ArrayUtil.inArray(this.originalFormData.repEntityAccess,id);
                    break;
                case 2: // Reporting Unit Access
                    return ArrayUtil.inArray(this.originalFormData.repUnitAccess,id);
                    break;
            }
        },
        isAccessNew(level,id) {
            switch(level) {
                case 0: // Reporting Group Access
                    return ArrayUtil.inArray(this.newFormData.repGroupAccess,id);
                    break;
                case 1: // Reporting Entity Access
                    return ArrayUtil.inArray(this.newFormData.repEntityAccess,id);
                    break;
                case 2: // Reporting Unit Access
                    return ArrayUtil.inArray(this.newFormData.repUnitAccess,id);
                    break;
            }
        },
        selectSubmissionType(data,type){
            var accessIdsToUpdate = [];
            
            // Apply new submission type for selected group/entity
            this.$set(data,'formSubmissionType',type);
            accessIdsToUpdate.push(data.accessId);

            if (data.accessLevel=='Reporting Group') {
                // Apply selected submission type under this group 
                if (data.reportingEntities.length > 0) {
                    data.reportingEntities.forEach(entity=>{
                        // Apply to Reporting Entities
                        entity.formSubmissionType = type;
                        accessIdsToUpdate.push(entity.accessId);

                        if (entity.reportingUnits.length > 0) {
                            entity.reportingUnits.forEach(unit=>{
                                // Apply to Reporting Units
                                unit.formSubmissionType = type;
                                accessIdsToUpdate.push(unit.accessId);
                            })
                        }
                    });
                }
            }
            else if (data.accessLevel=='Reporting Entity') {
                if (data.reportingUnits.length > 0) {
                    data.reportingUnits.forEach(unit=>{
                        // Apply to Reporting Units
                        unit.formSubmissionType = type;
                        accessIdsToUpdate.push(unit.accessId);
                    })
                }
            }

            var newAccessData = {
                accessIds : accessIdsToUpdate,
                accessLevel : data.accessLevel,
                formIdFk : this.formId,
                fieldName : 'formSubmissionType',
                fieldValue : type,
                updatedBy : this.profile.userId
            };

            this.saveSetting(newAccessData);
        },
        selectDisplayOption(data,option){
            var accessIdsToUpdate = [];
            // Apply new submission type for selected group/entity
            this.$set(data,'displayOption',option);
            accessIdsToUpdate.push(data.accessId);

            if (data.accessLevel=='Reporting Group') {
                // Apply selected submission type under this group 
                if (data.reportingEntities.length > 0) {
                    data.reportingEntities.forEach(entity=>{
                        // Apply to Reporting Entities
                        entity.displayOption = option;
                        accessIdsToUpdate.push(entity.accessId);

                        if (entity.reportingUnits.length > 0) {
                            entity.reportingUnits.forEach(unit=>{
                                // Apply to Reporting Units
                                unit.displayOption = option;
                                accessIdsToUpdate.push(unit.accessId);
                            })
                        }
                    });
                }
            }
            else if (data.accessLevel=='Reporting Entity') {
                if (data.reportingUnits.length > 0) {
                    data.reportingUnits.forEach(unit=>{
                        // Apply to Reporting Units
                        unit.displayOption = option;
                        accessIdsToUpdate.push(unit.accessId);
                    })
                }
            }

            var newAccessData = {
                accessIds : accessIdsToUpdate,
                accessLevel : data.accessLevel,
                formIdFk : this.formId,
                fieldName : 'displayOption',
                fieldValue : option,
                updatedBy : this.profile.userId
            };

            this.saveSetting(newAccessData);
        },
        saveSetting(accessData){
            if (!this.globalLoading) {
                this.globalLoading = this.$loading.open({
                    container: null
                });
            }
            FormAccessApi.update(accessData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.globalLoading.close()
                        this.$notification.open({
                            duration: 3000,
                            message: 'Saved!',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        this.getForm();
                    }
                    else {
                        this.globalLoading.close()
                        this.promptServerError({response},'FormAccess.update');
                    }
                }
            })
            .catch(error=>{
                this.globalLoading.close()
                this.promptServerError(error,'FormAccess.update');
            })
        },
        saveFormSetting(proceed){
            if (proceed==1) {
                this.activeStep = 2;
                return false;
            }
            this.$router.push({path:this.backLink});
        },
        openPreviewForm(){
            this.$router.push({path:"/admin/forms/"+this.originalFormData.formId+'/preview?reportingYear='+this.routeReportingYear});
        },
        updatedFormFileField(publish){
            FormsApi.updateFileField({
                enableFileUpload : this.enableFileUpload,
                formId : this.newFormId,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isUpdated) {
                            /*if (this.originalFormData.isPublished == true) {
                                this.publishForm()
                            }
                            else {*/
                                if (this.globalLoading) {
                                    this.globalLoading.close();
                                }
                                this.$dialog.confirm({
                                    title: "Success",
                                    message: "Form successfully copied. To further edit the form, click 'Edit Form'. Othwerise, click 'Back to Forms'.",
                                    cancelText: "Back to Forms",
                                    confirmText: "Edit Form",
                                    type: 'is-success',
                                    onConfirm: () => {
                                        this.$router.push({path:"/admin/forms/"+this.newFormId+'/edit?reportingYear='+this.selectedReportingYear});
                                    },
                                    onCancel: ()=>{
                                        this.$router.push({path:"/admin/forms/?reportingYear="+this.selectedReportingYear});
                                    }
                                });
                            // }
                            /* if (publish == 0) {
                                this.$notification.open({
                                    duration: 3000,
                                    message: 'Form saved!',
                                    position: 'is-bottom-left',
                                    type: 'is-success'
                                });
                                this.$router.push({path:this.backLink});
                            }
                            else {
                                this.publishForm()
                            } */ 
                        }
                    }
                    else {
                        if (this.globalLoading) {
                            this.globalLoading.close();
                        }
                        this.promptServerError({response},'Form.updateFileField');
                    }
                }
            })
            .catch(error=>{
                if (this.globalLoading) {
                    this.globalLoading.close();
                }
                this.promptServerError(error,'Form.updateFileField');
            })
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        closeError(){
            this.globalError.show = false;
            this.globalError.message = "";
        },
        showError(msg){
            this.globalError.show = true;
            this.globalError.message = msg;
        },
        hasSameSubmissionType(group){
            if (group.reportingEntities.length) {
                let numSame = group.reportingEntities.filter(re=>{
                    return re.formSubmissionType==group.formSubmissionType
                })
                if (numSame.length == group.reportingEntities.length) {
                    return true
                }
                return false
            }
        },
        hasSameDisplayOption(group){
            if (group.reportingEntities.length) {
                let numSame = group.reportingEntities.filter(re=>{
                    return re.displayOption==group.displayOption
                })
                if (numSame.length == group.reportingEntities.length) {
                    return true
                }
                return false
            }
        },
        applySettingToAll(group){

            if (group) {
                this.globalLoading = this.$loading.open({
                    container: null
                })
                var gformSubmissionType = group.formSubmissionType 
                var gDisplayOption = group.displayOption 
                var accessIds = [group.accessId]

                if (group.reportingEntities.length > 0) {
                    group.reportingEntities.forEach(ent=>{
                        accessIds.push(ent.accessId)

                        if (ent.reportingUnits.length > 0) {
                            ent.reportingUnits.forEach(unt=>{
                                accessIds.push(unt.accessId)
                            })
                        }
                    })
                }

                var newAccessData = {
                    accessIds : accessIds,
                    accessLevel : '',
                    formIdFk : this.formId,
                    fieldName : '',
                    fieldValue : '',
                    displayOption: gDisplayOption,
                    formSubmissionType: gformSubmissionType,
                    updatedBy : this.profile.userId
                };

                this.saveSetting(newAccessData)
            }
        },
        confirmDeleteAccess (data,level) {
            if (data) {
                var accessIds = [data.accessId]

                this.$dialog.confirm({
                    title: 'Delete Access Confirmation',
                    message: `This action will delete ${data[level]} (Id: ${data.accessId}) access to this form. If you're not sure with this transaction, please click 'Keep Access' and inform the site administrator. Otherwise, click 'Delete Access' to proceed.`,
                    cancelText: "Delete Access",
                    confirmText: "Keep Access",
                    type: 'is-danger',
                    onConfirm: () => {
                        
                    },
                    onCancel: ()=> {
                        this.deleteGroupAccess(accessIds)
                    }
                });
            }
        },
        deleteGroupAccess(accessIds) {
            if (!this.globalLoading) {
                this.globalLoading = this.$loading.open({
                    container: null
                })
            }
            FormAccessApi.delete({
                accessIds
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.globalLoading.close();
                        this.$notification.open({
                            duration: 5000,
                            message: 'Form access updated. Removed some access.',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        // To get updated access for the next step
                        this.getForm();
                    }
                    else {
                        this.globalLoading.close();
                        if (response.data.error.hasOwnProperty('code') &&
                            response.data.error.code==220) {
                            this.$dialog.alert({
                                title: 'Error: Unable to delete',
                                message: response.data.error.message,
                                type: 'is-danger'
                            });
                            return false;
                        }
                        this.promptServerError({response},'FormAccess.delete');
                    }
                }
            })
            .catch(error=>{
                this.globalLoading.close();
                this.promptServerError(error,'FormAccess.delete');
            })
        },

        addNewFormData(){

            if (this.newFormData.formName.trim()=="") {
                return false
            }
            // if (this.formNameInvalid) {
            //     return false
            // }
            if (this.newFormData.repGroupAccess.length==0) {
                this.showError('Please select at least one reporting group and entity for form access.');
                return false
            }

            if (this.govGroupValid()==false) {
                this.showError('Please select at least one entity from selected reporting group.');
                return false
            }

            if (this.otherGroupValid()==false){
                this.showError('Please select at least one entity from selected reporting group.');
                return false
            }
            
            // Form data is ready for submission

            this.addNewFormPromise = true;

            // Get Access
            var selectedRepGroup = this.repGroupLov.filter(group=>{
                // Get checked reporting groups
                return (ArrayUtil.inArray(this.newFormData.repGroupAccess,group.repGroupId))
            });

            if (selectedRepGroup.length > 0) {

                selectedRepGroup.forEach(group=>{
                    group.selectedRepEntities = group.reportingEntities.filter(entity=>{
                        // Get checked reporting groups
                        return (ArrayUtil.inArray(this.newFormData.repEntityAccess,entity.repEntityId))
                    })
                })

                selectedRepGroup.forEach(group=>{
                    group.selectedRepEntities.forEach(entity=>{
                        entity.selectedRepUnits = [];
                        entity.selectedRepUnits = entity.reportingUnits.filter(unit=>{
                            // Get checked reporting groups
                            return (ArrayUtil.inArray(this.newFormData.repUnitAccess,unit.repUnitId))
                        })
                    })
                });

                var formAccess = [];

                /** Copy existing form access */
                if (this.groupedFormAccess.length > 0) {
                    this.groupedFormAccess.forEach(group=>{
                        formAccess.push({
                            accessLevel : 'Reporting Group',
                            repGroupIdFk : group.repGroupIdFk,
                            repEntityIdFk : null,
                            repUnitIdFk : null,
                            formSubmissionType : group.formSubmissionType,
                            displayOption : group.displayOption,
                            addedBy: this.profile.userId
                        })

                        if (group.reportingEntities.length > 0) {
                            group.reportingEntities.forEach(entity=>{
                                formAccess.push({
                                    accessLevel : 'Reporting Entity',
                                    repGroupIdFk : entity.repGroupIdFk,
                                    repEntityIdFk : entity.repEntityIdFk,
                                    repUnitIdFk : null,
                                    formSubmissionType : entity.formSubmissionType,
                                    displayOption : entity.displayOption,
                                    addedBy: this.profile.userId
                                })

                                if (entity.reportingUnits.length > 0) {
                                    entity.reportingUnits.forEach(unit=>{
                                        formAccess.push({
                                            accessLevel : 'Reporting Unit',
                                            repGroupIdFk : unit.repGroupIdFk,
                                            repEntityIdFk : unit.repEntityIdFk,
                                            repUnitIdFk : unit.repUnitIdFk,
                                            formSubmissionType : unit.formSubmissionType,
                                            displayOption : unit.displayOption,
                                            addedBy: this.profile.userId
                                        })
                                    })
                                }
                            })
                        }
                    })
                }

                /* selectedRepGroup.forEach(group=>{

                    // Form access data for submission
                    formAccess.push({
                        accessLevel : 'Reporting Group',
                        repGroupIdFk : group.repGroupId,
                        repEntityIdFk : null,
                        repUnitIdFk : null,
                        formSubmissionType : "Single",
                        displayOption : "List",
                        addedBy: this.profile.userId
                    })
                    
                    group.selectedRepEntities.forEach(entity=>{

                        // Form access data for submission
                        formAccess.push({
                            accessLevel : 'Reporting Entity',
                            repGroupIdFk : entity.repGroupIdFk,
                            repEntityIdFk : entity.repEntityId,
                            repUnitIdFk : null,
                            formSubmissionType : "Single",
                            displayOption : "List",
                            addedBy: this.profile.userId
                        })

                        if (entity.selectedRepUnits.length > 0) {

                            entity.selectedRepUnits.forEach(unit=>{
                                // Form access data for submission
                                formAccess.push({
                                    accessLevel : 'Reporting Unit', 
                                    repGroupIdFk : entity.repGroupIdFk,
                                    repEntityIdFk : unit.repEntityIdFk,
                                    repUnitIdFk : unit.repUnitId,
                                    formSubmissionType : "Single",
                                    displayOption : "List",
                                    addedBy: this.profile.userId
                                });
                            });
                        }

                    });

                }); */

                // If formName is existing already, 
                // check if form access is different;
                let hasSameAccess = true;
                
                if (this.formNameInvalid) {
                    if (formAccess.length > 0) {

                        if (this.existingFormAccess.length > 0) {
                            let existingRepGrpAccess = [], existingRepEntAccess = [], existingRepUnitAccess = [];
                            let newRepGrpAccess = [], newRepEntAccess = [], newRepUnitAccess = [];

                            existingRepGrpAccess = this.filterAccessDataById(this.existingFormAccess,'Reporting Group','repGroupIdFk');
                            existingRepEntAccess = this.filterAccessDataById(this.existingFormAccess,'Reporting Entity','repEntityIdFk');
                            existingRepUnitAccess = this.filterAccessDataById(this.existingFormAccess,'Reporting Unit','repUnitIdFk');

                            newRepGrpAccess = this.filterAccessDataById(formAccess,'Reporting Group','repGroupIdFk');
                            newRepEntAccess = this.filterAccessDataById(formAccess,'Reporting Entity','repEntityIdFk');
                            newRepUnitAccess = this.filterAccessDataById(formAccess,'Reporting Unit','repUnitIdFk');

                            // Check existing form access has the same reporting assignment 
                            if (JSON.stringify(existingRepGrpAccess)==JSON.stringify(newRepGrpAccess) &&
                                JSON.stringify(existingRepEntAccess)==JSON.stringify(newRepEntAccess) &&
                                JSON.stringify(existingRepUnitAccess)==JSON.stringify(newRepUnitAccess) ) {
                                hasSameAccess = true;
                            }
                            else {
                                // Check if existing form access is a subset of new reporting assignment
                                let isRgSubset = existingRepGrpAccess.every(function(val) { 
                                    return (newRepGrpAccess.indexOf(val) >= 0); 
                                }); 
                                let isRpSubset = existingRepEntAccess.every(function(val) { 
                                    return (newRepEntAccess.indexOf(val) >= 0); 
                                }); 
                                let isRuSubset = existingRepUnitAccess.every(function(val) { 
                                    return (newRepUnitAccess.indexOf(val) >= 0); 
                                }); 

                                // If existing form access is a subset new form access
                                if (isRgSubset && isRpSubset && isRuSubset) {
                                    hasSameAccess = true; 
                                }
                                else {
                                    hasSameAccess = false;
                                }

                            }

                        }
                        else {
                            hasSameAccess = false;
                        }
                    }
                }

                if (this.formNameInvalid) {
                    if (hasSameAccess==true) {
                        // this.formNameErrorMessage = 'Form name exists and has same form access. Please select a different name or access.';
                        
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Looks like this form already exists. The system found a form with the same name and detected a similiar group/entity assignment. Please check your input and try again.",
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa'
                        });
                        this.addNewFormPromise = false;
                        return false;
                    }
                } 
                // Submit
                FormsApi.add({
                    formData : {
                        formName: this.newFormData.formName,
                        isActive: true,
                        isPublished: false,
                        createdBy: this.profile.userId,
                        reportingYear: this.selectedReportingYear
                    },
                    accessData : formAccess
                })
                .then(response=>{
                    var data = response.data;
                    var formId = null, formAccessData = [];
                    if (response.data) {
                        if (!response.data.error) {
                            // Get form id
                            if (data.formId!==null) {
                                formId = data.formId;
                                this.savedFormData = {
                                    formId : data.formId
                                }
                                /** Assign new form ID */
                                this.newFormId = data.formId
                            } 
                            // Get form access
                            if (data.formAccess!==null) {
                                formAccessData = data.formAccess;

                                // Initialize entities array in group access
                                formAccessData.repGroupAccess.forEach(group=>{
                                    group.reportingEntities = []
                                });

                                // Initialize units array in entity access
                                // Add entities to corresponding group access
                                formAccessData.repEntityAccess.forEach(entity=>{
                                    entity.reportingUnits = [];
                                    var groupIdx = ArrayUtil.getIndex(formAccessData.repGroupAccess,'repGroupIdFk',entity.repGroupIdFk);
                                    if (groupIdx!=null) {
                                        formAccessData.repGroupAccess[groupIdx].reportingEntities.push(entity);
                                    }
                                });

                                // Add units to corresponding entity access
                                formAccessData.repUnitAccess.forEach(unit=>{
                                    var entityIdx = ArrayUtil.getIndex(formAccessData.repEntityAccess,'repEntityIdFk',unit.repEntityIdFk);
                                    if (entityIdx!=null) {
                                        formAccessData.repEntityAccess[entityIdx].reportingUnits.push(unit);
                                    }
                                });

                                this.groupedFormAccess = formAccessData.repGroupAccess;
                            } 

                            /*this.$notification.open({
                                duration: 5000,
                                message: 'Form added. Select submission type and display option.',
                                position: 'is-bottom-left',
                                type: 'is-success'
                            });*/

                            this.addNewFormPromise = false;
                            this.isFormNameAccessSuccess = true;
                            this.isFormAccessSettingSuccess = false;
                            // this.activeStep = 1;

                            this.getOriginalFields()
                        }
                        else {
                            this.addNewFormPromise = false;
                            this.promptServerError({response},'Form.add');
                        }
                    }
                })
                .catch(error=>{
                    this.promptServerError(response,'Form.add');
                    this.addNewFormPromise = false;
                })
            }
        },
        hasOptions(id){
            let fieldTypes = ['dropdown','checkbox','radio'];
            let selectedInput = this.inputTypesLov.filter(inputType=>{
                return (inputType.typeId == id)
            });
            if (selectedInput[0]) {
                if (ArrayUtil.inArray(fieldTypes,selectedInput[0].inputType)){
                    return true;
                }
            }
            return false;
        },
        getInputType(id){
            let selectedInput = "";
            this.inputTypesLov.forEach(inputType=>{
                if (inputType.typeId==id) {
                    selectedInput = inputType.inputType;
                }
            });
            return selectedInput
        },
        getOriginalFields() {
            var formFields = [];
            if (this.originalFormData.formFields.length > 0) {
                this.originalFormData.formFields.forEach(field=>{

                    let currField = {};
                    let customOptValues = [];

                    for (var prop in field) {
                        if (prop!='optionType') {
                            this.$set(currField,prop,field[prop]);
                        }
                    }

                    this.$set(currField,'formIdFk',this.formId);
                    
                    // For dropdown field
                    this.$set(currField,'dropdownInput','');
                    this.$set(currField,'selectedPresetOption','');

                    if (field.inputType=='dropdown' ||
                        field.inputType=='checkbox' ||
                        field.inputType=='radio') {
                        if (field.optionType=='preset') {
                            this.$set(currField,'optionType','preset');
                            field.selectedPresetOption = ''
                            if (field.options.length > 0) {
                                field.selectedPresetOption = field.options[0].optionValue;
                                this.$set(currField,'selectedPresetOption',field.options[0].optionValue);
                            }   
                        }
                        else {
                            this.$set(currField,'optionType','custom');
                            if (field.options.length > 0) {
                                field.customDropdownOptions = [];
                                field.options.forEach(opt=>{
                                    field.customDropdownOptions.push(opt.optionValue)
                                    customOptValues.push(opt.optionValue)
                                })
                            }
                        }
                    }
                    else {
                        this.$set(currField,'optionType','preset');
                    }

                    this.$set(currField,'customDropdownOptions',customOptValues);

                    // Keep old values
                    // field.originalPropValues = Object.assign({},field);
                    this.$set(currField,'originalPropValues',Object.assign({},field));
                    
                    formFields.push(currField);
                });
                var fieldsWithOpts = [];
                var fieldsWithoutOpts = [];
                var errorCnt = 0;

                formFields.forEach(field=>{
                    if (field.fieldLabel=="") {
                        errorCnt++;
                    }
                    if (field.fieldTypeIdFk==null) {
                        errorCnt++;
                    }
                    if (field.fieldTypeIdFk!=null && field.fieldLabel!="") {
                        if (this.hasOptions(field.fieldTypeIdFk)) {
                            if (this.getInputType(field.fieldTypeIdFk)=='dropdown') {
                                if (field.selectedPresetOption.trim().length==0 && 
                                    field.customDropdownOptions.length==0) {    
                                    errorCnt++;
                                }
                            }
                            if (this.getInputType(field.fieldTypeIdFk)=='checkbox' || 
                                this.getInputType(field.fieldTypeIdFk)=='radio') {
                                if (field.customDropdownOptions.length==0) {    
                                    errorCnt++;
                                }
                            }
                            if (field.selectedPresetOption.trim().length > 0) {
                                field.optionType = "preset";
                            }
                            else if (field.customDropdownOptions.length > 0) {
                                field.optionType = "custom";
                            }
                            // fieldsWithOpts.push(field);
                            fieldsWithOpts.push({
                                addedBy: this.profile.userId,
                                customDropdownOptions: field.customDropdownOptions,
                                dropdownInput: field.dropdownInput,
                                fieldGroupLabel: field.fieldGroupLabel,
                                fieldLabel: field.fieldLabel,
                                fieldSubLabel: field.fieldSubLabel,
                                fieldTypeIdFk: field.fieldTypeIdFk,
                                formIdFk: this.newFormId,
                                hasMultipleInputValue: false,
                                isRequired: field.isRequired,
                                optionType: field.optionType,
                                selectedPresetOption: field.selectedPresetOption,
                                selectedPresetOptions: field.selectedPresetOptions,
                                sequenceNumber: field.sequenceNumber
                            });
                        }
                        else {
                            // fieldsWithoutOpts.push(field) 
                            fieldsWithoutOpts.push({
                                addedBy: this.profile.userId,
                                customDropdownOptions: field.customDropdownOptions,
                                dropdownInput: field.dropdownInput,
                                fieldGroupLabel: field.fieldGroupLabel,
                                fieldLabel: field.fieldLabel,
                                fieldSubLabel: field.fieldSubLabel,
                                fieldTypeIdFk: field.fieldTypeIdFk,
                                formIdFk: this.newFormId,
                                hasMultipleInputValue: false,
                                isRequired: field.isRequired,
                                optionType: field.optionType,
                                selectedPresetOption: field.selectedPresetOption,
                                selectedPresetOptions: [],
                                sequenceNumber: field.sequenceNumber
                            });
                        }
                    }
                });

                this.saveInputFields(fieldsWithoutOpts,fieldsWithOpts,0)
            }
        },
        saveInputFields(fields,dropdownFields,publish){
            // (emittedData) {
            // var fields = emittedData.fields;
            // var dropdownFields = emittedData.dropdownFields;
            // var publish = emittedData.publish;
            if (!this.newFormId) {
                return false
            }
            FormFieldsApi.add(fields)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.saveDropdownFields(dropdownFields,publish);
                    }
                    else {
                        if (this.globalLoading) {
                            this.globalLoading.close();
                        }
                        this.promptServerError({response},'FormFields.add');
                    }
                }
            })
            .catch(error=>{
                if (this.globalLoading) {
                    this.globalLoading.close();
                }
                this.promptServerError(error,'FormFields.add');
            })
        },
        saveDropdownFields(dropdownFields,publish){
            if (!this.newFormId) {
                return false
            }
            FormFieldsApi.addOne(dropdownFields)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (publish==1) {
                            // this.publishForm();
                        }
                        else {
                            /* this.$notification.open({
                                duration: 3000,
                                message: 'Fields added!',
                                position: 'is-bottom-left',
                                type: 'is-success'
                            });
                            this.areFormFieldsAdded = true;
                            this.activeStep++; */
                        }
                        this.updatedFormFileField()
                    }
                    else {
                        if (this.globalLoading) {
                            this.globalLoading.close();
                        }
                        this.promptServerError({response},'FormFields.addOne')
                    }
                }
            })
            .catch(error=>{
                if (this.globalLoading) {
                    this.globalLoading.close();
                }
                this.promptServerError(error,'FormFields.addOne');
            });
        },
        publishForm(){
            FormsApi.publish({
                formId : this.newFormId,
                updatedBy : this.profile.userId,
                action : 'publish'
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (this.globalLoading) {
                            this.globalLoading.close();
                        }
                        this.$dialog.confirm({
                            title: "Success",
                            message: "Form successfully copied. To further edit the form, click 'Edit Form'. Othwerise, click 'Back to Forms'.",
                            cancelText: "Back to Forms",
                            confirmText: "Edit Form",
                            type: 'is-success',
                            onConfirm: () => {
                                this.$router.push({path:"/admin/forms/"+this.newFormId+'/edit?reportingYear='+this.routeReportingYear});
                            },
                            onCancel: ()=>{
                                this.$router.push({path:"/admin/forms/?reportingYear="+this.routeReportingYear});
                            }
                        });
                        /* this.$notification.open({
                            duration: 3000,
                            message: 'Form is published!',
                            position: 'is-bottom-left',
                            type: 'is-success'
                        });
                        this.$router.push({path:this.backLink}); */
                    }
                    else {
                        if (this.globalLoading) {
                            this.globalLoading.close();
                        }
                        this.promptServerError({response},'Form.publish');
                    }
                }
            })
            .catch(error=>{
                if (this.globalLoading) {
                    this.globalLoading.close();
                }
                this.promptServerError(error,'Form.publish');
            });
        }
    }
}
</script>

<template>
    <section 
        v-if="originalFormData.formName"
        style="position:relative;">
        <div class="base-box--sidepadded">
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li>
                        <a 
                            v-bind:href="'#'+backLink">
                            Forms
                        </a>
                    </li>
                    <li class="is-active"><a href="#" aria-current="page">Copy</a></li>
                </ul>
            </nav>
        </div>

        <div class="field is-grouped">
            <div class="control">
                <p class="subtitle page-title">{{originalFormData.formName}}</p>
            </div>
            <p class="control">
                <button type="button"
                    class="button is-primary is-inverted"
                    v-on:click="openPreviewForm"
                    style="margin-top:0.8em;">
                    <span class="icon">
                        <i class="fas fa-eye"></i>
                    </span>
                    <span>Preview</span>
                </button>
            </p>
        </div>

        <div class="section no-padd"
            style="padding-left:1.5rem !important;padding-bottom:1rem !important;">
            <b-message 
                type="is-info">
                To duplicate this form, change the form name and click 'Save As New Form'. In Copy Fields section, don't forget to click 'Copy Fields'.
            </b-message>

            <div class="has-text-left is-italic">
                Fields marked with * are mandatory.
            </div>

            <div class="notification is-danger"
                v-if="globalError.show">
                <button class="delete"
                    type="button"
                    v-on:click="closeError"></button>
                <p>{{globalError.message}}</p>
            </div>
        </div>

        <div class="section no-padd--top app-view"
            v-if="!isLoading">

            <b-steps v-model="activeStep"
                v-bind:animated="true"
                v-bind:has-navigation="false">
                
                <!-- Step 1 : Name & Access -->
                <b-step-item 
                    label="Name and Access"
                    v-bind:clickable="true"
                    v-bind:type="{'is-success': isFormNameAccessSuccess}">

                    <div class="box">
                        <!-- <p class="title is-4">Form Name and Access</p> -->
                        <div class="new-form-details-box">

                            <b-field label="Reporting Year">
                                <b-select placeholder="Choose reporting year"
                                    v-model="selectedReportingYear"
                                    required>
                                    <option
                                        v-for="(year,yearIdx) in reportingYearLov"
                                        v-bind:key="yearIdx"
                                        v-bind:value="year">
                                        {{year}}
                                    </option>
                                </b-select>
                            </b-field> <br/>

                            <b-field label="New Form Name"
                                v-bind:type="{'is-success':formNameInvalid==false,
                                              'is-danger':newFormData.formName.trim().length==0}"
                                v-bind:message="formNameErrorMessage">
                                <b-input
                                    v-model="newFormData.formName" 
                                    value=""
                                    maxlength="50"
                                    required
                                    v-on:blur="checkFormName"
                                    v-bind:loading="formNamePromise"></b-input>
                            </b-field>


                            <div class="field">
                                <div class="field-label is-normal has-text-left">
                                    <label class="label">Choose who has access to this form</label>
                                </div>
                                <div class="field-body" style="margin-top:5px;">
                                    <div class="columns is-multiline is-mobile">
                                        <div class="column is-4" 
                                            v-for="(repGroup,repGroupIdx) in repGroupLov"
                                            v-bind:key="repGroupIdx">
                                            <div class="box">
                                                <p class="control">
                                                    <b-checkbox 
                                                        v-model="newFormData.repGroupAccess"
                                                        v-bind:native-value="repGroup.repGroupId"
                                                        v-on:change.native="checkAccess(0,repGroup)">
                                                        <span class="subtitle is-5 has-text-weight-medium">{{repGroup.reportingGroup}}</span>
                                                    </b-checkbox>
                                                </p>

                                                <div v-if="repGroup.reportingEntities.length > 0 && isGroupSelected(repGroup)"
                                                    class="form-access-grp__sub--entity">

                                                    <span class="subtitle is-6 has-text-weight-semibold">
                                                        <span v-if="repGroup.reportingGroup!=govAgencyGroup">ALL</span> 
                                                        {{repGroup.reportingGroup}}
                                                    </span>
                                                    <span class="is-italic has-text-info"
                                                        v-if="repGroup.reportingGroup!=govAgencyGroup"><br/>*Uncheck to exclude an entity</span><br/>

                                                    <div class="field"
                                                        v-for="(entity,entityIdx) in repGroup.reportingEntities"
                                                        v-bind:key="entityIdx">
                                                        
                                                        <p class="control">
                                                            <b-checkbox 
                                                                v-model="newFormData.repEntityAccess"
                                                                v-bind:native-value="entity.repEntityId"
                                                                v-on:change.native="checkAccess(1,repGroup,entity)">
                                                                {{entity.reportingEntity}}
                                                            </b-checkbox>
                                                        </p>

                                                        <div v-if="entity.reportingUnits.length > 0 && isEntitySelected(entity)"
                                                            class="form-access-grp__sub--unit">

                                                            <span class="subtitle is-6 has-text-weight-semibold">Reporting Units</span><br/>
                                                            <span class="is-italic has-text-info">*Uncheck to exclude a unit</span><br/>

                                                            <div class="field"
                                                                v-for="(repUnit,repUnitIdx) in entity.reportingUnits"
                                                                v-bind:key="repUnitIdx">
                                                                <p class="control">
                                                                    <b-checkbox 
                                                                        v-model="newFormData.repUnitAccess"
                                                                        v-bind:native-value="repUnit.repUnitId">
                                                                        {{repUnit.reportingUnit}}
                                                                    </b-checkbox>
                                                                </p>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="is-divider"></div>
                        <div class="buttons">
                            <a class="button"
                                v-on:click="cancel">
                                Cancel
                            </a>
                            <a class="button is-success"
                                v-bind:class="{'is-loading':formNamePromise==true}"
                                v-on:click="addNewFormData">
                                <!-- v-bind:disabled="!(isFormValid && nameAccessChanged)" -->
                                Save As New Form
                            </a>
                        </div>
                    </div>
                    <!-- End: Name & Access -->
                </b-step-item>
                
                <!-- Step 2: Access Restriction (formId and accessIds are created) -->
                <b-step-item 
                    label="Form Setting per Access"
                    v-bind:type="{'is-success': isFormAccessSettingSuccess}">
                    <div>
                        <!-- Card implementation -->
                        <div class="columns is-multiline is-mobile">
                            <div class="column is-one-third"
                                v-for="(group,groupIdx) in groupedFormAccess"
                                v-bind:key="groupIdx">
                                <div class="box">
                                    <!-- header -->
                                    <div>
                                        <p class="subtitle is-4">{{group.reportingGroup}} (Id: {{group.accessId}})</p>
                                    </div>
                                    <div 
                                        style="padding-top:0.4rem;padding-bottom:0.4rem;">
                                        <table width="100%"
                                            class="form-options-table">
                                            <tr 
                                                v-if="(!group.sameSubmissionType || !group.sameDisplayOption) && group.reportingGroup!==govAgencyGroup">
                                                <td style="padding:0.4rem">
                                                    <span class="has-text-weight-semibold">
                                                        Apply to All
                                                    </span>
                                                </td>
                                                <td style="padding:0.4rem;padding-left:10%">
                                                    <b-field>
                                                        <b-switch
                                                            type="is-info"
                                                            v-model="group.appliedToAll"
                                                            v-on:input="applySettingToAll(group)">
                                                            {{group.appliedToAll==true ? 'Yes' : 'No'}}
                                                        </b-switch>
                                                    </b-field>
                                                </td>
                                            </tr>
                                            <tr v-if="group.reportingGroup!==govAgencyGroup">
                                                <td style="padding:0.4rem">
                                                    <span class="has-text-weight-semibold">
                                                        Submission Type
                                                    </span>
                                                </td>
                                                <td width="50%"
                                                    style="padding:0.4rem;padding-left:10%">
                                                    <div class="buttons has-addons are-small">
                                                        <span class="button"
                                                            v-bind:class="{'is-info is-selected' : group.formSubmissionType=='Single'}"
                                                            v-on:click="selectSubmissionType(group,'Single')">
                                                            Single
                                                        </span>
                                                        <span class="button"
                                                            v-bind:class="{'is-info is-selected' : group.formSubmissionType=='Multiple'}"
                                                            v-on:click="selectSubmissionType(group,'Multiple')">
                                                            Multiple
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="group.reportingGroup!==govAgencyGroup">
                                                <td style="padding:0.4rem">
                                                    <span class="has-text-weight-semibold">
                                                        Display
                                                    </span>
                                                </td>
                                                <td style="padding:0.4rem;padding-left:10%">
                                                    <div class="buttons has-addons are-small">
                                                        <a class="button"
                                                            v-bind:class="{'is-info is-selected' : group.displayOption=='List'}"
                                                            v-on:click="selectDisplayOption(group,'List')">
                                                            <span class="icon">
                                                                <i class="fas fa-th-list"></i>
                                                            </span>
                                                            <span>List</span>
                                                        </a>
                                                        <a class="button"
                                                            v-bind:class="{'is-info is-selected' : group.displayOption=='Table'}"
                                                            v-on:click="selectDisplayOption(group,'Table')">
                                                            <span class="icon">
                                                                <i class="fas fa-columns"></i>
                                                            </span>
                                                            <span>Table</span>
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <!-- <tr v-if="group.reportingGroup!==govAgencyGroup">
                                                <td class="has-text-left"
                                                    style="padding:0.4rem">
                                                    <a class="button is-light"
                                                        type="button"
                                                        v-on:click="confirmDeleteAccess(group,'reportingGroup')">
                                                        <span class="icon">
                                                            <i class="fas fa-trash"></i>
                                                        </span>
                                                        <span>Delete</span>
                                                    </a>
                                                </td>
                                                <td></td>
                                            </tr> -->
                                        </table>
                                    </div>

                                    <!-- Entities --> 
                                    <span class="has-text-weight-semibold">Entities/Units</span>
                                    <div style="min-height:300px;max-height:350px;overflow-y:scroll;padding:0.4rem"
                                        v-if="group.reportingGroup!=govAgencyGroup && group.reportingEntities.length > 0">
                                        <ul>
                                            <li v-for="(entity,entityIdx) in group.reportingEntities"
                                                v-bind:key="entityIdx"
                                                class="form-options__row--entity"
                                                style="padding-bottom:0.3rem">
                                                <div>
                                                    <span 
                                                        class="tag"
                                                        :class="entity.formSubmissionType!='Single' ? 'is-grey has-text-success' : 'is-grey has-text-danger'">
                                                        {{entity.formSubmissionType}}
                                                    </span> 
                                                    <span class="tag"
                                                        :class="entity.displayOption!='Table' ? 'is-gray has-text-info' : 'is-grey has-text-dark'">
                                                        {{entity.displayOption}}
                                                    </span> 
                                                    <span class="entity-name"
                                                        :title="`${entity.reportingEntity} (Id:${entity.accessId})`">{{entity.reportingEntity}}</span>
                                                </div>
                                                <!-- Uncomment to enable delete access
                                                <div class="has-text-right"
                                                    style="padding:0.4rem">
                                                    <a class="button is-light"
                                                        type="button"
                                                        v-on:click="confirmDeleteAccess(entity,'reportingEntity')">
                                                        <span class="icon">
                                                            <i class="fas fa-trash"></i>
                                                        </span>
                                                        <span>Delete</span>
                                                    </a>
                                                </div> -->
                                                <div v-if="entity.reportingUnits.length > 0"
                                                    style="margin-top:0.3rem;">
                                                    <ul v-if="entity.reportingUnits.length > 0">
                                                        <li 
                                                            v-for="(unit,unitIdx) in entity.reportingUnits"
                                                            v-bind:key="unitIdx"
                                                            style="padding-bottom:0.3rem;border-top:1px dashed rgb(225, 225, 225);">
                                                            <span class="tag"
                                                                :class="unit.formSubmissionType!='Single' ? 'is-grey has-text-success' : 'is-grey has-text-danger'">
                                                                {{unit.formSubmissionType}}
                                                            </span> 
                                                            <span class="tag"
                                                                :class="unit.displayOption!='Table' ? 'is-gray has-text-info' : 'is-grey has-text-dark'">
                                                                {{unit.displayOption}}
                                                            </span> 
                                                            <span class="unit-name" 
                                                                :title="`${unit.reportingUnit} (Id:${unit.accessId})`">{{unit.reportingUnit}}</span>
                                                            <!-- Uncomment to enable delete access
                                                            <div class="has-text-right"
                                                                style="padding:0.4rem">
                                                                <a class="button is-light"
                                                                    type="button"
                                                                    v-on:click="confirmDeleteAccess(unit,'reportingUnit')">
                                                                    <span class="icon">
                                                                        <i class="fas fa-trash"></i>
                                                                    </span>
                                                                    <span>Delete</span>
                                                                </a>
                                                            </div> -->
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <!-- If gov agency -->
                                    <div
                                        v-if="group.reportingGroup==govAgencyGroup && group.reportingEntities.length > 0"
                                        style="padding-top:0.4rem;padding-bottom:0.4rem;">
                                        <table width="100%"
                                            class="form-options-table"
                                            v-for="(entity,entityIdx) in group.reportingEntities"
                                            v-bind:key="entityIdx"
                                            style="border-top:1px dashed rgb(225, 225, 225)">
                                            <tbody>
                                                <tr>
                                                    <td colspan="2"
                                                        style="padding:0.4rem">
                                                        <span 
                                                            class="tag"
                                                            :class="entity.formSubmissionType!='Single' ? 'is-grey has-text-success' : 'is-grey has-text-danger'">
                                                            {{entity.formSubmissionType}}
                                                        </span> 
                                                        <span class="tag"
                                                            :class="entity.displayOption!='Table' ? 'is-gray has-text-info' : 'is-grey has-text-dark'">
                                                            {{entity.displayOption}}
                                                        </span> 
                                                        <span class="has-text-weight-semibold entity-name">{{entity.reportingEntity}} (Id: {{entity.accessId}})</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="padding:0.4rem">
                                                        <span class="has-text-weight-light">
                                                            Submission Type
                                                        </span>
                                                    </td>
                                                    <td width="50%"
                                                        style="padding:0.4rem;padding-left:10%">
                                                        <div class="buttons has-addons are-small">
                                                            <span class="button"
                                                                v-bind:class="{'is-info is-selected' : entity.formSubmissionType=='Single'}"
                                                                v-on:click="selectSubmissionType(entity,'Single')">
                                                                Single
                                                            </span>
                                                            <span class="button"
                                                                v-bind:class="{'is-info is-selected' : entity.formSubmissionType=='Multiple'}"
                                                                v-on:click="selectSubmissionType(entity,'Multiple')">
                                                                Multiple
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="padding:0.4rem">
                                                        <span class="has-text-weight-light">
                                                            Display
                                                        </span>
                                                    </td>
                                                    <td style="padding:0.4rem;padding-left:10%">
                                                        <div class="buttons has-addons are-small">
                                                            <a class="button"
                                                                v-bind:class="{'is-info is-selected' : entity.displayOption=='List'}"
                                                                v-on:click="selectDisplayOption(entity,'List')">
                                                                <span class="icon">
                                                                    <i class="fas fa-th-list"></i>
                                                                </span>
                                                                <span>List</span>
                                                            </a>
                                                            <a class="button"
                                                                v-bind:class="{'is-info is-selected' : entity.displayOption=='Table'}"
                                                                v-on:click="selectDisplayOption(entity,'Table')">
                                                                <span class="icon">
                                                                    <i class="fas fa-columns"></i>
                                                                </span>
                                                                <span>Table</span>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="has-text-left"
                                                        style="padding:0.4rem">
                                                        <a class="button is-light"
                                                            type="button"
                                                            v-on:click="confirmDeleteAccess(entity,'reportingEntity')">
                                                            <span class="icon">
                                                                <i class="fas fa-trash"></i>
                                                            </span>
                                                            <span>Delete</span>
                                                        </a>
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                            <tbody v-if="entity.reportingUnits.length > 0">
                                                <tbody
                                                    v-for="(unit,unitIdx) in entity.reportingUnits"
                                                    v-bind:key="unitIdx">
                                                    <tr>
                                                        <td colspan="2"
                                                            style="padding:0.4rem">
                                                            <span 
                                                                class="tag"
                                                                :class="unit.formSubmissionType!='Single' ? 'is-grey has-text-success' : 'is-grey has-text-danger'">
                                                                {{unit.formSubmissionType}}
                                                            </span> 
                                                            <span class="tag"
                                                                :class="unit.displayOption!='Table' ? 'is-gray has-text-info' : 'is-grey has-text-dark'">
                                                                {{unit.displayOption}}
                                                            </span> 
                                                            <span class="has-text-weight-semibold entity-name">{{unit.reportingEntity}} (Id: {{unit.accessId}})</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding:0.4rem">
                                                            <span class="has-text-weight-light">
                                                                Submission Type
                                                            </span>
                                                        </td>
                                                        <td width="50%"
                                                            style="padding:0.4rem;padding-left:10%">
                                                            <div class="buttons has-addons are-small">
                                                                <span class="button"
                                                                    v-bind:class="{'is-info is-selected' : unit.formSubmissionType=='Single'}"
                                                                    v-on:click="selectSubmissionType(unit,'Single')">
                                                                    Single
                                                                </span>
                                                                <span class="button"
                                                                    v-bind:class="{'is-info is-selected' : unit.formSubmissionType=='Multiple'}"
                                                                    v-on:click="selectSubmissionType(unit,'Multiple')">
                                                                    Multiple
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <!-- Uncomment to enable delete access 
                                                    <tr>
                                                        <td class="has-text-left"
                                                            style="padding:0.4rem">
                                                            <a class="button is-light"
                                                                type="button"
                                                                v-on:click="confirmDeleteAccess(unit,'reportingUnit')">
                                                                <span class="icon">
                                                                    <i class="fas fa-trash"></i>
                                                                </span>
                                                                <span>Delete</span>
                                                            </a>
                                                        </td>
                                                        <td></td>
                                                    </tr> -->
                                                </tbody>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="is-divider"></div>
                        <div class="buttons">
                            <a class="button"
                                v-on:click="saveFormSetting(0)">
                                Cancel
                            </a>
                            <a class="button is-success"
                                v-on:click="saveFormSetting(1)">
                                Save Changes
                            </a>
                        </div>
                    </div>
                </b-step-item>

                <!-- Step 3: Form Fields (formId) -->
                <b-step-item 
                    label="Copy Fields"
                    v-bind:type="{'is-success': areFormFieldsAdded}">

                    <EditFieldsForm
                        v-bind:repGroupLov="repGroupLov"
                        v-bind:inputTypesLov="inputTypesLov"
                        v-bind:originalFormData="originalFormData"
                        v-bind:profile="profile"
                        v-bind:mode="'Copy'"
                        v-bind:newFormId="newFormId"
                        v-on:save-fields-copy="saveInputFields">
                    </EditFieldsForm>
                    
                </b-step-item>

                <!-- Step 4: Enable File Upload -->
                <b-step-item
                    label="Enable File Upload">

                    <div class="box form-fields-box">

                        <strong>Allow users to upload file/s to this form.</strong>
                        <div class="buttons has-addons">
                            <span class="button"
                                v-bind:class="{'is-info is-selected' : enableFileUpload}"
                                v-on:click="enableFileUpload=true">
                                Yes
                            </span>
                            <span class="button"
                                v-bind:class="{'is-info is-selected' :  !enableFileUpload}"
                                v-on:click="enableFileUpload=false">
                                No
                            </span>
                        </div>

                        <hr />
                        
                        <div class="columns">                 
                            <div class="column">
                                <a class="button"
                                    v-on:click="updatedFormFileField(0)">
                                    Save & Close
                                </a>
                                <a class="button is-success"
                                    v-on:click="updatedFormFileField(1)">
                                    Save & Publish Form
                                </a>
                            </div>  
                        </div>
                        
                    </div>
                </b-step-item>
            </b-steps>
        </div>
    </section>
</template>

<style scoped>
.form-access-grp {
    border:1px solid #e5e5e5;
    padding:5px 8px 0px 8px;
    border-radius:4px;
    margin-bottom:3px;
    min-width: 33%;
}
.form-access-grp__sub--entity{
    margin:1em auto;
    margin-left:2em;
    padding-right:1em;
}

.form-access-grp__sub--unit{
    margin:1em auto;
    margin-left:2.15em;
}

.form-access-grp__sub--entity .field,
.form-access-grp__sub--unit .field {
    border:none;
    border-top:1px solid #e5e5e5;
    padding: 7px 4px 5px 2px;
}

.form-restriction-table thead {
    border-bottom:2px solid rgb(165, 165, 165);
}

.form-restriction-table th {
    padding: 5px;
    padding-bottom: 10px;
}

.form-group-row {
    border-top:1px solid #e5e5e5;
    border-bottom:1px solid #e5e5e5;
    background-color: #f5f5f5;
}

.repgroup-row {
    background-color: #f5f5f5;
}
.entity-row {
    border-top: 1px solid #f4f4f4;
    padding-top:0.5rem;
    padding-bottom:0.5rem;
}
.entity-row .entity-name {
    font-size: 13px;
}
.unit-row {
    border-top: 1px solid #f4f4f4;
    padding-top:0.5rem;
    padding-bottom:0.5rem;
}
.unit-row .unit-name {
    padding-left: 1rem;
    color: gray;
    font-size: 13px;
}

.form-group-row > td {
    padding: 5px 0px 5px 5px;
}

.form-group-row:first-child > td {
    padding-top: 0.7em;
}
.form-group-row--entity {
    border-top: 1px solid #f4f4f4
}
.form-group-row--entity > td {
    padding-top:0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.35em;
}
.form-group-row--entity > td:first-child {
    padding-left: 0.75em;
}

.form-group-list__units {
    display: block;
    margin-top: 0.6rem;
    margin-left: 4rem;
    border-top: 1px solid #f4f4f4;
    padding-top: 0.6rem;

}

.link {
    color: #209cee;
    cursor: pointer;
}
.link:hover {
    text-decoration: underline
}
.main-heading {
    margin-bottom: 0.6rem;
}
.form-options-table tr:hover {
    background-color:#f7f7f7;
}
.form-options__row--entity {
    padding:0.3rem;
    border-bottom:1px dashed rgb(225, 225, 225);
}
.form-options__row--entity:hover {
    background-color:#fef8f0;
}
</style>




// WEBPACK FOOTER //
// src/views/administration/CopyFormView.vue